//This file is generated from c# do not modify, any changes will be overridden when re-generated.
import { ModelBase } from "../../pillar/common/models/ModelBase";

export class CalOmsExtractWorkspaceModel extends ModelBase {
  static readonly $typeName = 'CalOmsExtractWorkspaceModel';
  public providerExtractKey: string;
  public fsn: string;
  public transactionDateTime: Date;
  public providerId: string;
  public providersParticipantIdentifier: string;
  public clientFirstName: string;
  public clientLastName: string;
  public typeOfForm: string;
  public admissionDate: Date;
  public annualUpdateDischargeDate: Date;
  public submittedToCalOMS: boolean;
  public lastUploadToStateDate: Date;
  public reasonForNotSubmitting: string;
  public extractGenerateDate: Date;
  public reportMonth: string;

}



// WEBPACK FOOTER //
// ./src/app/extracts/models/CalOmsExtractWorkspaceModel.ts